// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantForm-moduleformBody__SZP7C";
export { _1 as "formBody" }
